import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { DatePicker } from "@mui/lab";
import { IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getAmplifyToken } from "../../../util/AmplifyHelp";
import ErrorPopUp from "../../../components/Pop_ups/ErrorPopUp";
import TextPopUp from "../../../components/Pop_ups/TextPopUp";
import LoadingPopUp from "../../../components/Pop_ups/LoadingPopUp";
import validator from "validator";
import moment from "moment";
import "./Resource.css";


export const CreateNewResource = ({ refresh, setRefresh, profile }) => {

  const defaultResourceRoles = {
    admin:false,
    offers:false,
    timesheet_admin:false,
    timesheet:true
  }
  const [open, setOpen] = React.useState(false);
  const [openStatus, setOpenStatus] = React.useState(false);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [roleObj, setRoleObj] = useState(defaultResourceRoles)

  const [newEntry, editNewEntry] = useState({
    firstName: "",
    lastName: "",
    contactNumber: "",
    primaryEmail: "",
    secondaryEmail: "",
    resourceCategory: "Developer",
    hireDate: null,
    location: "",
  });

  const updateEntry = (field, value) => {
    let temp = {
      ...newEntry,
    };
    temp[field] = value;
    editNewEntry(temp);
  };
  const updateDate = (field, value) => {
    let temp = {
      ...newEntry,
    };
    temp[field] = moment.utc(value).format("YYYY-MM-DD").toString();
    editNewEntry(temp);
  };
  const updateContact = (e) =>{
    const onlyDigits = e.replace(/\D/g, "");
    updateEntry("contactNumber", onlyDigits)

  }
  const updateEmail = (field, e) =>{
    const removeWhitespace = e.replace(/\s/g, '');
    console.log("onlyDigits", removeWhitespace)
    updateEntry(field, removeWhitespace)
  }
  const handleOpen = () => setOpen(true);
  const handleClose = (event, reason) => {
    if (reason && reason == "backdropClick") {
      if(newEntry.firstName !== "" || newEntry.lastName !== "" || newEntry.primaryEmail !== "")
          return;
  }
    setOpen(false);
    editNewEntry({
      firstName: "",
      lastName: "",
      contactNumber: "",
      primaryEmail: "",
      secondaryEmail: "",
      resourceCategory: "Developer",
      hireDate: null,
      location: "",
    });
    setRoleObj(defaultResourceRoles)
  };


  const onSaveHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    if (
      newEntry.firstName === "" ||
      newEntry.lastName === "" ||
      newEntry.primaryEmail === "" ||
      newEntry.resourceCategory === ""
    ) {
      setLoading(false);
      setOpenStatus(true);
      setMessage("Please complete the required sections of the form!");
    } else if (
      !validator.isEmail(newEntry.primaryEmail) ||
      (!validator.isEmail(newEntry.secondaryEmail) && newEntry.secondaryEmail)
    ) {
      setLoading(false);
      setOpenStatus(true);
      setMessage("Invalid email format. Please try again!");
    } else {
      getAmplifyToken((jwt) => {
        fetch(`${process.env.REACT_APP_ADMIN_API}/admin/resources-api`, {
          method: "POST",
          body: JSON.stringify({
            firstName: newEntry.firstName,
            lastName: newEntry.lastName,
            primaryEmail: newEntry.primaryEmail,
            secondaryEmail: newEntry.secondaryEmail ? newEntry.secondaryEmail : undefined,
            category: "6",
            hireDate: newEntry.hireDate ? newEntry.hireDate : undefined,
            location: newEntry.location ? newEntry.location : undefined,
            contactNumber: newEntry.contactNumber ? newEntry.contactNumber : undefined,
            roleObj : roleObj
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: jwt,
          },
        }).then((response) => {
          setLoading(false);
          if (response.ok) {
            setSuccess(true);
            setMessage(
              `${newEntry.firstName} ${newEntry.lastName}` +
                " has been added as a resource!"
            );
            handleClose();
          } else {
            setOpenStatus(true);
            setMessage("Could not load from the database. Please try again!");
          }
        });
      });
    }
  };

  return (
    <div className="entry-container">
      <TextPopUp
        title="Success!"
        content={message}
        open={success}
        onClose={(event) => {
          event.preventDefault();
          setSuccess(false);
          setRefresh(!refresh);
        }}
        fullWidth
      />
      <ErrorPopUp
        open={openStatus}
        onClose={(e) => {
          e.preventDefault();
          setOpenStatus(false);
        }}
        errorContent={message}
      />
      <LoadingPopUp open={loading} />
      <Button sx={{margin:'0'}}variant="outlined" onClick={handleOpen}>
        Create New Resource
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DialogTitle>
          <Typography align='center' variant='h6'>Enter Resource Information</Typography>
          <Box display='flex' justifyContent='flex-end'>
                <IconButton
                  fullWidth
                  sx={{ display: "flex" }}
                  variant="contained"
                  onClick={handleClose}
                >
                  <CloseIcon />
                </IconButton>
                </Box>
        </DialogTitle>
        <DialogContent>
          {
            <div className="values-container">
              <TextField
                sx={{ width: "100%", margin: "5px" }}
                placeholder=""
                label="First Name"
                mode="outlined"
                required
                onChange={(event) => {
                  updateEntry("firstName", event.target.value);
                }}
              />
              <TextField
                sx={{ width: "100%", margin: "5px" }}
                placeholder=""
                label="Last Name"
                mode="outlined"
                required
                onChange={(event) => {
                  updateEntry("lastName", event.target.value);
                }}
              />
              <TextField
                sx={{ width: "100%", margin: "5px" }}
                placeholder=""
                label="Primary Email"
                mode="outlined"
                required
                onChange={(event) => {
                  updateEmail("primaryEmail", event.target.value);
                }}
              />
              <TextField
                sx={{ width: "100%", margin: "5px" }}
                placeholder=""
                label="Contact Number"
                mode="outlined"
                onChange={(event) => {
                  updateContact(event.target.value);
                }}
              />
              <TextField
                sx={{ width: "100%", margin: "5px" }}
                placeholder=""
                label="Secondary Email"
                mode="outlined"
                onChange={(event) => {
                  updateEmail("secondaryEmail", event.target.value);
                }}
              />
              <DatePicker
                error={false}
                helperText={null}
                label="Hire Date"
                value={newEntry.hireDate ? moment.utc(newEntry.hireDate) : null}
                onChange={(value) => {
                  updateDate("hireDate", value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={false}
                    sx={{ width: "100%", margin: "5px" }}
                  />
                )}
              />
              <TextField
                sx={{ width: "100%", margin: "5px" }}
                placeholder=""
                label="Location"
                mode="outlined"
                onChange={(event) => {
                  updateEntry("location", event.target.value);
                }}
              />
            </div>
          }
          {
            <div className="button-container">
              <Button
                sx={{ width: "40%", backgroundColor:'#ff6600', color: 'white', borderColor:'#ff6600', '&:hover': {
                  backgroundColor: '#fff',
                  color: '#ff6600'}}}
                  variant="contained"
                  onClick={onSaveHandler}
              >
                Save
              </Button>{" "}
            </div>
          }
        </DialogContent>
      </Dialog>
    </div>
  );
};
